import { render, staticRenderFns } from "./OpenedOrders.vue?vue&type=template&id=262ab682&scoped=true"
import script from "./OpenedOrders.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenedOrders.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OpenedOrders.vue?vue&type=style&index=0&id=262ab682&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262ab682",
  null
  
)

export default component.exports